import { adyenService } from '@/api/adyen.service';
import { registerPlugin, type Plugin } from '@capacitor/core';

export interface IAdyenPlugin extends Plugin {
  openDeviceSelection(): Promise<void>;
  initPosSession(): Promise<void>;
  getMethods(): Promise<{
    tapToPay: boolean;
    cardReader: boolean;
  }>;
  initializePayment({
    amount,
    currency,
    adyenData,
    method,
  }: {
    amount: number;
    currency: string;
    reference: string;
    adyenData: {
      metadata: Record<string, string>;
      shopperReference: string | undefined;
      shopperEmail: string | undefined;
      recurringProcessingModel?: 'UnscheduledCardOnFile';
      shopperStatement?: string;
      tenderOption?: string;
      additionalData?: {
        manualCapture?: 'true' | 'false';
        authorisationType: 'PreAuth' | 'FinalAuth';
      };
    };
    method: 'cardReader' | 'tapToPay';
  }): Promise<any>;
  resetSession(): Promise<void>;
  needsTapToPayLinking(): Promise<{
    needsTapToPayLinking: boolean;
  }>;
  linkTapToPay(): Promise<void>;
}

(window as any).getAdyenSdkData = async (setupToken: string) => {
  return await adyenService
    .posSession(setupToken)
    .then((response) => {
      return response.sdkData;
    })
    .catch(() => {
      return null;
    });
};

const AdyenPlugin = registerPlugin<IAdyenPlugin>('Adyen');
export default AdyenPlugin;
